<div class="chartFrame middle">
  @if (chartData.noData) {
    <div class="chartCenter">
      <p>no data</p>
    </div>
  } @else {
    <div class="chartCenter">
      @if (chartData.first) {
        <h1>
          {{ chartData.first[0].toString() | percentage: chartData.first[1].toString() }}
        </h1>
      }
      @if (chartData.first) {
        <p>{{ chartData.first[2] }}</p>
      }
      @if (chartData.second) {
        <p>=================</p>
      }
      @if (chartData.second) {
        <h1>
          {{ chartData.second[0].toString() | percentage: chartData.second[1].toString() }}
        </h1>
      }
      @if (chartData.second) {
        <p>{{ chartData.second[2] }}</p>
      }
      @if (!chartData.first && !chartData.second) {
        <p>
          <b>distribution of</b>
        </p>
      }
      @if (!chartData.first && !chartData.second) {
        <p>
          <b>uploads per file type</b>
        </p>
      }
    </div>
  }
  <div
    class="chartRing"
    style="display: block">
    <canvas
      baseChart
      [data]="chartData.data"
      [labels]="chartData.labels"
      [options]="chartData.options"
      [type]="'doughnut'"></canvas>
  </div>
</div>
